import { Link } from "react-router-dom";

export default function PaymentCancel() {
  return (
    <div className="flex min-h-screen items-center justify-center px-6" data-testid="payment-cancel-page">
      <div className="w-full max-w-md rounded-2xl border-2 border-[#F5F2EB] bg-[#141414] p-10 text-center shadow-[8px_8px_0_#F5F2EB]">
        <h1 className="font-serif text-3xl font-black uppercase tracking-tight">No charge made</h1>
        <p className="mt-4 text-sm leading-relaxed text-[#F5F2EB]/60">
          Checkout was canceled — the piece is still on the rack if you want it.
        </p>
        <Link
          to="/"
          data-testid="payment-cancel-back-link"
          className="mt-8 inline-block rounded-full border-2 border-[#F5F2EB] bg-[#141414] px-8 py-3 text-xs font-mono font-medium uppercase tracking-[0.2em] text-[#F5F2EB] transition-all hover:-translate-y-0.5 hover:shadow-[4px_4px_0_#F5F2EB]"
        >
          Back to the rack
        </Link>
      </div>
    </div>
  );
}
